
import {
	Box,
	Button,
	Grid,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import validator from "validator";
import {CheckboxInput, ChoiceInput, DatePickerInput, ListChoiceInput, MailInput, TextInput} from "../Inputs";
import {organizationType, sportsorganizationType} from "../../constants/AccountType";
import getProIndeInfoFromEapsAPI from "../../services/getProIndeInfoFromEapsAPI";
import { useSnackbar } from "notistack";
import HelperEapsAlert from "../PopUpAlert/HelperEapsAlert";
import {globalConfigDurationNotistack, status} from "../../constants/globalConstant";
import numSiretValidator from "../../utils/validator/numSiretValidator";
import { languages } from "../../constants/typeToText";
import {validUrlEAPS} from "../../utils/validator/checkIfValid";
import checkIfInseeApiIsWorking from "../../scenes/Account/services/checkIfInseeApiIsdown";

/**
 * return the default configuration for the given name
 * @param {string} name
 * @param {string} accountType
 * @param {any} value
 * @param {boolean} isFrenchCompany
 * @returns {{alwaysShowHelperText: boolean, labelText: string, isValid: (function(): boolean), id: string, placeholder: string, type: string, helperText: string}|{alwaysShowHelperText: boolean, labelText: string, isValid: (function(): boolean), id: string, placeholder: string, type: string, helperText: string}|{alwaysShowHelperText: boolean, labelText: string, isValid: (function(): boolean), id: string, placeholder: string, type: string, helperText: string}|{alwaysShowHelperText: boolean, labelText: string, isValid: (function()), id: string, placeholder: string, type: string, helperText: string}|{alwaysShowHelperText: boolean, labelText: string, isValid: (function(): boolean), id: string, placeholder: string, type: string, helperText: string}|{alwaysShowHelperText: boolean, labelText: string, isValid: (function(): boolean), placeholder: string, type: string, helperText: string}|{alwaysShowHelperText: boolean, labelText: string, values: string[], isValid: (function(): boolean), id: string, type: string, helperText: string}|{alwaysShowHelperText: boolean, labelText: string, isValid: (function(): boolean), placeholder: string, type: string, helperText: string}|{}|{alwaysShowHelperText: boolean, labelText: string, isValid: (function(): boolean), type: string, helperText: string}|{alwaysShowHelperText: boolean, labelText: string, values: *, isValid: (function(): boolean), id: string, type: string, helperText: string}|{alwaysShowHelperText: boolean, labelText: string, isValid: (function(): boolean), id: string, placeholder: string, type: string, helperText: string}|{alwaysShowHelperText: boolean, labelText: string, isValid: (function(): boolean), id: string, placeholder: string, type: string, helperText: string}|{isValid: (function(): boolean)}|{alwaysShowHelperText: boolean, labelText: string, isValid: (function(): boolean), id: string, placeholder: string, type: string, helperText: string}|{alwaysShowHelperText: boolean, labelText: string, isValid: (function(): boolean), placeholder: string, type: string, helperText: string}}
 */
const specificFormConfig = (name, accountType, value = null, isFrenchCompany ) => {

	switch (name) {
		// L'URL profil EAPS est désormais remplacé par le num carte pro qui suffit pour aller chercher les info sir l'api de eaps
		case "urlProfilEaps":
			return {
				id: 'profil-eaps',
				type: "text",
				labelText: "Numéro de carte professionnelle",
				placeholder: "00***ED****",
				isValid: function () {
					return true;
				},
				helperText: "Saisissez ICI votre numéro de carte professionnelle",
				alwaysShowHelperText: true,
			};

		case "firstName":
			return {
				id: 'name',
				type: "text",
				labelText: "Prénom",
				placeholder: "Jean",
				isValid: function () {
					return !validator.isEmpty(value) && (!value.includes("--") && !value.includes(" -") && !value.includes("- "));
				},
				helperText: "Veuillez ne pas renseigner 2 tirets à la suite ou un tiret et un espace à la suite.",
				alwaysShowHelperText: false,
			};
		case "lastName":
			return {
				id: 'lastname',
				type: "text",
				labelText: "Nom",
				placeholder: "Dupont",
				isValid: function () {
					return !validator.isEmpty(value) && (!value.includes("--") && !value.includes(" -") && !value.includes("- "));
				},
				helperText: "Veuillez ne pas renseigner 2 tirets à la suite ou un tiret et un espace à la suite.",
				alwaysShowHelperText: false,
			};
		case "isFrenchCompany":
			return {
				type: "radio-select",
				labelText: "Êtes-vous une entreprise française ? ",
				helperText: "Une entreprise française doit être référencer dans le répertoire interadministratif Sirene",
				isValid: function () {
					return true
				},
				alwaysShowHelperText: true
			};

		case "managerLang":
			return {
				id: 'manager-lang',
				type: "choice-list",
				labelText: "Langues parlées",
				values: languages.map((e) => e.value),
				isValid: function () {
					return value.length > 0;
				},
				helperText: "Plusieurs langues possibles",
				alwaysShowHelperText: true,
			};

		case "siret":
			if (isFrenchCompany){
				return {
					id: 'siret',
					type: "text",
					labelText: "Numéro SIRET",
					placeholder: "80295478500028",
					isValid: function () {
						return /^\d{14}$/.test(value);
					},
					helperText: "Votre numéro SIRET est composé de 14 chiffres et doit être référencé dans le " +
						"répertoire interadministratif Sirene!",
					alwaysShowHelperText: false,
				};
			}else {
				return {
					isValid: function () {
						return true;
					},
				};
			}
		case "vatNumber":
			if (!isFrenchCompany){
				return {
					id: 'vat',
					type: "text",
					labelText: "Numéro de TVA (VAT Number)",
					placeholder: "IT99999999999",
					isValid: function () {
						return !validator.isEmpty(value);
					},
					helperText: "Renseignez le numéro de TVA propre à votre entreprise!",
					alwaysShowHelperText: false,
				};
			}else {
				return {
					isValid: function () {
						return true;
					},
				};
			}

		case "birthDate":
			return {
				id: 'birthdate',
				type: "date",
				labelText: "Date de naissance",
				placeholder: "24/03/2020",
				isValid: function () {
					const dateToTest = new Date(value);
					const now = new Date();
					const diffMilli = Math.abs(now - dateToTest);
					const diffYear = diffMilli / 31556952000;
					return validator.isDate(value, "dd/MM/yyyy") && diffYear >= 13;
				},
				helperText: "Vous devez avoir au moins 13 ans pour vous inscrire !",
				alwaysShowHelperText: false,
			};
		case "sex":
			return {
				id: "gender",
				type: "choice",
				labelText: "Genre",
				values: ["Homme", "Femme", "Autre"],
				isValid: function () {
					return !validator.isEmpty(value);
				},
				helperText: "Vous avez forcément un genre !",
				alwaysShowHelperText: false,
			};
		case "name":
			return {
				type: "text",
				labelText: "Nom de votre société vu par vos clients",
				placeholder: "Le nom de ma société",
				isValid: function () {
					return !validator.isEmpty(value);
				},
				helperText: "Le nom de la société ne peut être vide !",
				alwaysShowHelperText: false,
			};
		case "status":
			if (accountType === sportsorganizationType) {
				return {
					type: "text",
					labelText: "Statut de la société",
					placeholder: "Exemple: École de ski",
					isValid: function () {
						return !validator.isEmpty(value);
					},
					helperText: "École de ski, club de sport, bureau des guides, club de fitness, ...",
					alwaysShowHelperText: true,
				};
			} else if (accountType === organizationType) {
				return {
					type: "text",
					labelText: "Statut de la société",
					placeholder: "Exemple: Agence immobilière",
					isValid: function () {
						return !validator.isEmpty(value);
					},
					helperText: "Hôtel, agence immobilière, agence événementiel, centre de formation  ...",
					alwaysShowHelperText: true,
				};
			} else return {}
		case "managerMail":
			return {
				id: 'manager-email',
				type: "mail",
				labelText: "Adresse mail du manager",
				placeholder: "john.doe@gmail.com",
				isValid: () => validator.isEmail(value),
				helperText: "L'adresse mail doit être valide !",
				alwaysShowHelperText: false,
			};
		case "managerFirstName":
			return {
				id: 'manager-name',
				type: "text",
				labelText: "Prénom du gérant",
				placeholder: "Jean",
				isValid: function () {
					return !validator.isEmpty(value);
				},
				helperText: "Le gérant a forcément un prénom !",
				alwaysShowHelperText: false,
			};
		case "managerLastName":
			return {
				id: 'manager-lastname',
				type: "text",
				labelText: "Nom du gérant",
				placeholder: "Dupont",
				isValid: function () {
					return !validator.isEmpty(value);
				},
				helperText: "Le gérant a forcément un nom !",
				alwaysShowHelperText: false,
			};
		//TODO do some test to check if form still valid ( before return false)
		default:
			return {
				isValid: function () {
					return true;
				},
			};
	}
};

function AccountSpecificFormManager({ accountType, accountSpecificValue, onChange, setValid }) {
	const [state, setState] = useState(accountSpecificValue);
	const [errorUrlEaps, setErrorUrlEaps] = useState(false);
	const [checkSiretGood, setCheckSiretGood] = useState(false);
	const { enqueueSnackbar } = useSnackbar();
	const [inseeStatus, setInseeStatus] = useState(status.working);

	useEffect(() => {
		checkIfInseeApiIsWorking()
			.then(() => setInseeStatus(status.working))
			.catch(() => setInseeStatus(status.down))
	}, [])

	const isValid = (name) => {
		if (name === " siret") {
			if (!state.isFrenchCompany){
				return true
			}

		} else {
			return specificFormConfig(
				name,
				accountType,
				state[name],
				state.isFrenchCompany ? state.isFrenchCompany : null
			).isValid();
		}

	};

	const formIsValid = () => {
		for (const key of Object.keys(state)) {
			if ( !isValid(key)) {
				// check for siret input if user enter before a good siret but after modify it and is not good, update
				// checkSiret to false to remake verif by INSEE Api
				if (key === "siret" && checkSiretGood){
					setCheckSiretGood(false);
				}
				return false;
			}
		}
		return true;
	};

	const checkWithApiSIRETValidity =  () => {
		if (!checkSiretGood ){
			numSiretValidator(state['siret'], inseeStatus)
				.then((data) => {
					setCheckSiretGood(data)
				})
		}
	}

	useEffect(() => {
		// If account type is OrganizationSport or ONS OrganizationNonSport check validity of siret by api INSEE
		if ((accountType === "sportsorganization" || accountType === "organization") && state.isFrenchCompany){
			checkWithApiSIRETValidity()
			setValid(formIsValid() && checkSiretGood);
		} else {
			setValid(formIsValid());
		}
		onChange(state);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state]);

	const handleInputChange = async (e) => {
		const target = e.target;
		const value = target.value;
		const name = target.name;
		if (name === "isFrenchCompany"){
			setState({
				...state,
				[name]: !state.isFrenchCompany,
			});
		} else {
			setState({
				...state,
				[name]: value,
			});
		}
	};

	const loadDataFromEAPS = () => {
		let urlProfilEaps = state.urlProfilEaps;
		
		if (validUrlEAPS(urlProfilEaps)){
			setErrorUrlEaps(false);
			getProIndeInfoFromEapsAPI(urlProfilEaps)
				.then((data) => {
					setState({
						...state,
						urlProfilEaps: urlProfilEaps,
						firstName: data.data.firstName,
						lastName: data.data.lastName,
						birthDate: new Date(data.data.birthAt),
						numCardPro: data.data.numCardPro,
						cardProExpiredAt: data.data.expiredAt,
						cardProDeliveryBy: data.data.giveBy,
						allQualification: data.data.allQualification
					});
				})
				.catch((err) => {
					setErrorUrlEaps(true);
					enqueueSnackbar("Saisissez un numéro de carte professionnelle valide "+err, {
						variant: "error",
						autoHideDuration: globalConfigDurationNotistack
					});
				})
		} else {
			setErrorUrlEaps(true);
			enqueueSnackbar("Saisissez un numéro de carte professionnelle valide", {
				variant: "error",
				autoHideDuration: globalConfigDurationNotistack
			});
		}
	}

	const content = Object.entries(state).map(([key, value], index) => {
		const config = specificFormConfig(key, accountType,null, state.isFrenchCompany ? state.isFrenchCompany : null);
		const isText = config.type === "text";
		const isMail = config.type === "mail";
		const isDate = config.type === "date";
		const isChoice = config.type === "choice";
		const isChoiceList = config.type === "choice-list";
		const isRadioSelect = config.type === "radio-select";
		const isEmpty = isChoiceList ? value.length === 0 : value === "";
		const error = key === "siret" ? (!isValid(key) || !checkSiretGood): (!isEmpty && !isValid(key));

		const helperText = ( config.alwaysShowHelperText || error ) && config.helperText;
		let input = null;

		if (isText) {
			input = (
				<TextInput
					id={config.id && config.id}
					name={key}
					labelText={config.labelText}
					labelShrink
					placeholder={config.placeholder}
					fullWidth
					value={value}
					handleChange={handleInputChange}
					disabled={config.disabled}
					error={
						key === "urlProfilEaps" ?
							errorUrlEaps :
							error
					}
					helperText={(key === "urlProfilEaps" && errorUrlEaps) ?
						"Veuillez saisir un numéro de carte professionnelle valdie" : helperText
					}
				/>
			);
		} else if (isMail) {
			input = (
				<MailInput
					id={config.id && config.id}
					name={key}
					value={value}
					labelText={config.labelText}
					labelShrink
					placeholder={config.placeholder}
					fullWidth
					handleChange={handleInputChange}
					error={error}
					helperText={helperText}
				/>
			);
		} else if (isDate) {
			input = (
				<DatePickerInput
					id={config.id && config.id}
					name={key}
					labelText={config.labelText}
					labelShrink
					fullWidth
					maxDate={new Date(new Date().setFullYear(new Date().getFullYear() - 13))}
					value={value}
					handleChange={(date) => {
						setState({
							...state,
							[key]: date,
						});
					}}
					error={error}
					helperText={helperText}
				/>
			);
		} else if (isChoice) {
			input = (
				<ChoiceInput
					id={config.id && config.id}
					name={key}
					labelText={config.labelText}
					labelShrink
					fullWidth
					value={value}
					values={config.values}
					handleChange={handleInputChange}
					error={error}
					helperText={helperText}
				/>
			);
		} else if (isChoiceList) {
			input = (
				<ListChoiceInput
					id={config.id && config.id}
					name={key}
					labelText={config.labelText}
					labelShrink
					fullWidth
					value={value}
					values={config.values}
					handleChange={handleInputChange}
					error={error}
					helperText={helperText}
				/>
			);
		}else if (isRadioSelect){
			input = (
				<CheckboxInput
					id={config.id && config.id}
					name={key}
					labelText={config.labelText}
					value={value}
					handleChange={handleInputChange}
					helperText={helperText}
				/>
			)
		}
		if (input != null){
			return (
				<Grid key={index} item xs={12}>
					{key === "urlProfilEaps" &&
						<HelperEapsAlert isOnRegisterView={true}/>
					}
					{input}
					{key === "urlProfilEaps" &&
						<Button
							variant="contained"
							color="primary"
							onClick={loadDataFromEAPS}
						>
							Charger mes informations
						</Button>
					}
				</Grid>
			);
		} else return <Box key={index}></Box>
	});

	return (
		<Grid container spacing={3}>
			{content}
		</Grid>
	);
}

export default AccountSpecificFormManager;
